export {CompanyDetailInterestsContainer as CompanyDetailInterests} from './container';
